module.exports = __webpack_public_path__ + "static/img/print.256ee0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print.png
// module id = wgZg
// module chunks = 10